class LoadCollections extends HTMLElement {
  connectedCallback() {
    // Select the 'See More' button and the 'See More Header' that are children of this custom element
    this.seeMoreButton = this.querySelector('.see-more');
    this.seeMoreHeader = this.querySelector('.see-more-header');

    // Attach a click event listener to the 'See More' button
    this.seeMoreButton.addEventListener('click', this.loadMore.bind(this));
  }

  loadMore() {
    let header = this.querySelector(".see-more-header");
    header.classList.add("loading");

    // Add the loading state to the 'See More' button
    this.seeMoreButton.classList.add('loading');

    fetch(`/?section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const newItems = html.querySelector("#CollectionList");
        this.appendChild(newItems);
        this.classList.remove("load-collections--loading");

        const nextPage = html.querySelector('load-collections');
        if (nextPage) {
          this.after(nextPage);
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        // Remove the loading state and show the loaded state briefly
        this.seeMoreButton.classList.remove("loading");
        this.seeMoreButton.classList.add("loaded");

        setTimeout(() => {
          this.seeMoreButton.classList.remove("loaded");
        }, 500);

        // Set the 'See More Header' to display: none
        this.seeMoreHeader.style.display = "none";

        // Optionally, you can hide or disable the 'See More' button after the content is loaded.
        this.seeMoreButton.classList.add("hidden");
        // this.seeMoreButton.disabled = true;
      });
  }
}

customElements.define("load-collections", LoadCollections);